module.exports = __webpack_public_path__ + "static/media/treslagoas.2b934815.mp3";